import React, {useCallback} from 'react';
import {callAction} from 'client/framework';
import Checkbox from 'generic/Forms/Checkbox/Checkbox.react';

import usageReportsStore from '../UsageReports.store';
import usageReportsActions from '../UsageReports.actions';

const ExpandSubjectsFilter = () => {
  const toggleExpandSubjects = useCallback(
    () => callAction(usageReportsActions.TOGGLE_EXPAND_SUBJECTS),
    []
  );
  return (
    <Checkbox
      label='Expand subjects'
      checked={usageReportsStore.areSubjectsExpanded()}
      onChange={toggleExpandSubjects}
    />
  );
};

export default ExpandSubjectsFilter;
